import { Observable } from "rxjs";
import { LayerItemV2 } from "../models/layer-item";
import { NativeLayer } from "../models/native-layer";

export abstract class BaseLayerProviderService {
  abstract type: string;
  abstract getWMS(layerItem: LayerItemV2): Observable<NativeLayer>;
  abstract getWFS(layerItem: LayerItemV2): Observable<NativeLayer>;
}
